import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Header7.css";

const Header7 = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="header7">

        {/* BRAND */}
        <div className="h7-brand">
          <span>PULSE</span>
        </div>

        {/* NAV */}
        <nav className="h7-nav">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/workouts">Workouts</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/plans">Pricing</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/trainers">Trainers</NavLink>
          <NavLink to="/faqs">FAQs</NavLink>
        </nav>

        {/* ACTIONS */}
        <div className="h7-actions">
          <NavLink to="/contact" className="h7-cta">Contact</NavLink>

          <div
            className={`h7-toggle ${open ? "open" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

      </header>

      {/* ================= MOBILE OVERLAY ================= */}
      <div className={`h7-overlay ${open ? "show" : ""}`}>
        <div className="overlay-inner">

          <div className="overlay-header">
            <span>PULSE</span>
            <button onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="overlay-links">
            <NavLink to="/" onClick={() => setOpen(false)}>Home</NavLink>
            <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
            <NavLink to="/workouts" onClick={() => setOpen(false)}>Workouts</NavLink>
            <NavLink to="/services" onClick={() => setOpen(false)}>Services</NavLink>
            <NavLink to="/plans" onClick={() => setOpen(false)}>Pricing</NavLink>
            <NavLink to="/gallery" onClick={() => setOpen(false)}>Gallery</NavLink>
            <NavLink to="/trainers" onClick={() => setOpen(false)}>Trainers</NavLink>
            <NavLink to="/faqs" onClick={() => setOpen(false)}>FAQs</NavLink>

            <NavLink
              to="/contact"
              className="overlay-cta"
              onClick={() => setOpen(false)}
            >
              Contact
            </NavLink>
          </div>

        </div>
      </div>
    </>
  );
};

export default Header7;
